import { Hand, PauseCircle } from 'lucide-react';
import { timeLabel } from './export-timing-words';
import type { PaigeExportWhen } from './export-types';
import '../renderer/export-route.css';

const hours = [
  { at: 0, label: '12 AM' },
  { at: 25, label: '6 AM' },
  { at: 50, label: 'Noon' },
  { at: 75, label: '6 PM' },
  { at: 100, label: '12 AM' },
];
const workTicks = [
  35, 36.8, 38.6, 41, 42.4, 44.9, 47.2, 49.6, 51.2, 54, 56.4, 58.1, 61, 63.5, 65.2, 68.3,
];

interface StripProps {
  when: PaigeExportWhen;
  at: string | null;
  paused: boolean;
}

/**
 * CapturePoint's 24-hour strip under "When documents leave" (renderer/ExportRoute.tsx, ExportWhenPanel), drawn for
 * Paige's choice: ticks through the working day for as soon as ready, one pin at the daily time, a hand for only when
 * I say, and the hold across the day while exports are paused. Decorative; the card's words say the same.
 */
export function ExportDayStrip(props: StripProps) {
  return (
    <div className="export-day" aria-hidden="true">
      <div className="export-day-strip">
        <i className="export-day-work" />
        <Marks {...props} />
      </div>
      <div className="export-day-hours">
        {hours.map((item) => (
          <span key={item.at} style={{ left: `${item.at}%` }}>
            {item.label}
          </span>
        ))}
      </div>
    </div>
  );
}

/** What the strip shows for the choice. */
function Marks({ when, at, paused }: StripProps) {
  if (paused)
    return <Note icon={<PauseCircle size={16} />} text="Paused: nothing leaves until you resume" />;
  if (when === 'manual')
    return <Note icon={<Hand size={16} />} text="Nothing leaves until you click Export now" />;
  if (when === 'ready')
    return workTicks.map((tick) => (
      <i key={tick} className="export-day-tick" style={{ left: `${tick}%` }} />
    ));
  const time = at ?? '18:00';
  const [hour = 18, minute = 0] = time.split(':').map(Number);
  const pin = ((hour * 60 + minute) / 1440) * 100;
  return (
    <>
      <i className="export-day-pin" style={{ left: `${pin}%` }} />
      <span className="export-day-pin-label" style={{ left: `${pin}%` }}>
        {timeLabel(time)}
      </span>
    </>
  );
}

function Note({ icon, text }: { icon: React.ReactNode; text: string }) {
  return (
    <span className="export-day-hand">
      {icon}
      {text}
    </span>
  );
}
